/** «Смена салона» — ровно то, что отдаёт `GET /api/salon/shift`. */
import { apiFetch, query } from "@/lib/api";

export type Queue = { morning: number | null; evening: number | null; delta: number | null };

export type Hours = {
  paid_h: number;
  customer_h: number;
  task_h: number;
  customer_pct: number | null;
  task_pct: number | null;
  opconv: number | null;
};

export type SalonDay = Hours & {
  date: string;
  move_queue: Queue;
  sbor_queue: Queue | null;
  tasks_done: number;
  people: number;
  roles: (Hours & { role_id: number; role: string })[];
};

export type SalonUser = Hours & {
  user_id: number;
  name: string;
  role_id: number;
  role: string;
  in_opconv: boolean;
  days: number;
  tasks_done: number;
};

export type Salon = {
  id: number;
  name: string;
  short: string;
  marketplace: boolean;
  total: Hours & { tasks_done: number };
  days: SalonDay[];
  users: SalonUser[];
};

export type SalonReport = {
  from: string;
  to: string;
  salons: Salon[];
  locations: { id: number; name: string; short: string }[];
};

export function loadSalonShift(p: { from: string; to: string; location: number }): Promise<SalonReport> {
  return apiFetch<SalonReport>(`/api/salon/shift${query(p)}`);
}

/** Опер-конверсия: как в statTotal CRM — от 70% зелёный, от 60% жёлтый. */
export function operClass(v: number | null): string {
  if (v === null) return "text-fg-faint";
  if (v >= 70) return "text-ok";
  if (v >= 60) return "text-warn";
  return "text-err";
}
